// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"8e2fe516","112":"567bba26","212":"567bba26","449":"ff5bcea8","468":"ff5bcea8","648":"4f159333","984":"ff5bcea8","996":"3ded5a25"}[chunkId] + ".chunk.css";
};